module.exports = __webpack_public_path__ + "static/media/banner_casino-half.adb56954.png";